<template>
    <div class="circle">
        <div class="circle-inner circle-1"/>
        <div class="circle-inner circle-2"/>
    </div>
</template>

<script>
    export default {
        name: 'circle-pulse',
    };
</script>

<style lang="less">
    @keyframes pulsate {
        0% {transform: scale(0.1, 0.1); opacity: 0.0;}
        50% {opacity: 1.0;}
        100% {transform: scale(1.2, 1.2); opacity: 0.0;}
    }

    .circle {
        width: 810px;
        height: 810px;
        position: relative;
    }

    .circle-inner {
        border: 1px solid rgba(255, 255, 255, 0.25);
        border-radius: 50%;
        animation-name: pulsate;
        animation: pulsate 5s ease-out;
        animation-iteration-count: infinite;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transform: scale(0.1, 0.1);
        opacity: 0.0;
        &.circle-2 {
            animation-delay: 2.5s;
        }
    }
</style>
